module.exports = __webpack_public_path__ + "media/images/lp/1/history4-pc-263c120935b804244b2b9fb702c0ea82.jpg";